import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper';

import {
    ACTION_TOGGLE_NAVIGATION_DRAWER,
    ACTION_NAVIGATION_DRAWER_CLEAR,
    NavigationDrawerAction,
    ACTION_SET_BREADCRUMBS,
    ACTION_CLEAR_BREADCRUMBS,
    ACTION_SET_DRAWER_ITEMS
} from '../actions/navigation';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState } from "./index";
import { INavItem } from 'src/components/layouts';

export interface INavigationDrawerState {
    isOpen: boolean,
    drawerItems: INavItem[],
    breadcrumbs: INavItem[],
}

const initialState: INavigationDrawerState = {
    isOpen: true,
    drawerItems: [],
    breadcrumbs: []
};


function _loading(state: INavigationDrawerState, _isLoading: boolean): INavigationDrawerState {
    const newState: INavigationDrawerState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function toggleNavigationDrawer(state: INavigationDrawerState,
    isOpen: boolean
): INavigationDrawerState {
    const newState: INavigationDrawerState = update(state, {
        isOpen: {
            $set: isOpen
        }
    });

    return newState;
}

function clear(state: INavigationDrawerState, propertiesToClear?: string[]): INavigationDrawerState {

    if (!propertiesToClear) {
        const newState: INavigationDrawerState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function setDrawerItems(state: INavigationDrawerState,
    drawerItems: INavItem[]
): INavigationDrawerState {
    const newState: INavigationDrawerState = update(state, {
        drawerItems: {
            $set: drawerItems
        }
    });

    return newState;
}

function setBreadcrumbs(state: INavigationDrawerState,
    breadcrumbs: INavItem[]
): INavigationDrawerState {
    const newState: INavigationDrawerState = update(state, {
        breadcrumbs: {
            $set: breadcrumbs
        }
    });

    return newState;
}

function clearBreadCrumbs(state: INavigationDrawerState): INavigationDrawerState {
    const newState: INavigationDrawerState = update(state, {
        breadcrumbs: {
            $set: []
        }
    });

    return newState;
}

const NavigationDrawerReducer: Reducer<INavigationDrawerState> = (state: INavigationDrawerState = initialState, action: NavigationDrawerAction) => {
    switch (action.type) {
        case ACTION_NAVIGATION_DRAWER_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TOGGLE_NAVIGATION_DRAWER:
            return toggleNavigationDrawer(state, action.isOpen);
        case ACTION_SET_DRAWER_ITEMS:
            return setDrawerItems(state, action.drawerItems);
        case ACTION_SET_BREADCRUMBS:
            return setBreadcrumbs(state, action.breadcrumbs);
        case ACTION_CLEAR_BREADCRUMBS:
            return clearBreadCrumbs(state);
    }

    return state;
}

export default NavigationDrawerReducer;